import { create as autoCreate } from "@microchip/scf-automodule-impl";
import { State } from "@microchip/scf-automodule-impl/lib/creator";
import { CreatorFunctions } from "@microchip/melody-automodule-interface";
import * as Creator from "@microchip/scf-common/lib/Creator";
import { getModuleConfigFromFile, getCreatorFunctions } from "./getUserData";

export type LegacyCreatorFunction = (state: State) => Creator.Module;

const createCreator = (
    getCreatorFunctions: () => CreatorFunctions,
): LegacyCreatorFunction => {
    const hook = (state: State): Creator.Module => {
        const creatorFunctionsGetter = (): CreatorFunctions => {
            return {
                getModuleConfig: getModuleConfigFromFile,
                ...getCreatorFunctions(),
            };
        };
        return autoCreate(state, creatorFunctionsGetter);
    };
    return hook;
};

export const create = createCreator(getCreatorFunctions);
